<template>
  <div class="content-accordion mb-12">
    <div class="space-y-4">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// Reiner Wrapper: jedes <accordion-item> verwaltet seinen offen/zu-Zustand
// selbst (lokaler State), damit Items unabhängig togglen.
export default {
  name: 'Accordion'
}
</script>